import React from "react"
import "./style.css"

const GlobalLoading = () => {
	return (
		<div className="global-loader-background">
			<span className="loader">
				<span className="loader-inner" />
			</span>
		</div>
	)
}

export default GlobalLoading
